import { connect } from 'react-redux';
import Loader from './Loader';
import { selector } from '../../store/reducers/loader';

const mapStateToProps = (state) => {
  const { loaders } = selector(state);
  if (loaders.length) {
    const { processId, description } = loaders[loaders.length - 1];
    return { processId, description };
  }
  return {};
};

export default connect(mapStateToProps)(Loader);
